import { render, staticRenderFns } from "./invadobay.vue?vue&type=template&id=a61cc3f2&scoped=true&"
import script from "./invadobay.vue?vue&type=script&lang=js&"
export * from "./invadobay.vue?vue&type=script&lang=js&"
import style0 from "./invadobay.vue?vue&type=style&index=0&id=a61cc3f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61cc3f2",
  null
  
)

export default component.exports